angular.module('tgaAdmin')
  .controller('ProgressController', [
    '$scope', '$state', '$timeout', 'gameService', 'playerService', 'statsService', '$filter', 'reportService',
    function (
      $scope, $state, $timeout, gameService, playerService, statsService, $filter, reportService,
    ) {
      $scope.data = {
        alerts: [],
        filedate: $filter('date')(new Date(), 'yyyy-MM-dd hh-mm-ss'),
        separator: ',',
        decimalSeparator: '.',
      };

      $scope.viewmodel = {
        players: [],
        dateFilter: {
          startDate: null,
          endDate: null,
        },
      };

      $scope.initialize = function () {
        $scope.actions.loadPlayerProgress();
      };

      $scope.actions = {
        loadPlayerProgress() {
          $scope.loading = true;

          $scope.viewmodel.players = [];

          playerService.getProgress().then((players) => {
            $scope.viewmodel.players = players;
            $scope.loading = false;
          });
        },
        exportPlayerStats() {
          const reportData = [];

          reportData.push(['Name', 'Email Address', 'Progress']);

          for (let i = 0; i < $scope.viewmodel.players.length; i++) {
            const { progress } = $scope.viewmodel.players[i].meta;

            if (!progress) {
              reportData.push([
                $scope.viewmodel.players[i].display_name,
                $scope.viewmodel.players[i].email,
              ]);
            } else {
              const pkeys = Object.keys(progress);
              pkeys.sort();

              for (let j = 0; j < pkeys.length; j++) {
                const row = [
                  $scope.viewmodel.players[i].display_name,
                  $scope.viewmodel.players[i].email,
                ];
                row.push(pkeys[j]);

                const keys = Object.keys(progress[pkeys[j]]);
                keys.sort();

                for (let k = 0; k < keys.length; k++) {
                  row.push(keys[k]);
                }

                reportData.push(row);
              }
            }
          }

          return reportData;
        },
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },

        generateReportFilename: reportService.generateReportFilename,
      };

      $scope.initialize();
    },
  ]);
